import _ from "lodash";
import { STATE_NAME } from "./error.constants";

export const getErrorMessage = state => _.get(state, "error.Message");

export const getErrorState = state => state[STATE_NAME];

export const getErrorType = state => state[STATE_NAME].Error;
